// src/api/mockData.js
export const defaultUserInfo = {
  avatarUrl: 'https://tuhenmei.com/zb_users/upload/2023/06/2023061316866172392.jpg',
  name: 'pigStar',
  intro: '这个人很神秘，什么也没留下。',
  detailIntro: '欢迎来到我的博客！请登陆后完善您的个人信息！',
  email: 'pigStar@gmail.com',
  techStack: '暂无',
  hobbies: '暂无',
  github: '#',
  homepage: '#'
};